module.exports = __webpack_public_path__ + "img/headRight3Logo.a885fba7.png";